/**
 * AuthLanding — runs the magic-link redemption.
 */

import { useEffect, useRef, useState } from 'react';
import { redeemAuthToken } from '../lib/api';

interface Props {
  authToken?: string;
  navigate: (path: string) => void;
}

export default function AuthLanding({ authToken, navigate }: Props) {
  const [failedReason, setFailedReason] = useState<string | null>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    if (!authToken) {
      navigate('/portal/error?reason=invalid_or_expired');
      return;
    }

    (async () => {
      const res = await redeemAuthToken(authToken);
      if (res?.success === true) {
        navigate('/portal');
      } else {
        const reason = (res as any)?.reason || 'invalid_or_expired';
        setFailedReason(reason);
        window.setTimeout(() => {
          navigate(`/portal/error?reason=${encodeURIComponent(reason)}`);
        }, 200);
      }
    })();
  }, [authToken, navigate]);

  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 p-8 text-center max-w-md mx-auto">
      <div className="inline-block w-8 h-8 border-4 border-blue-600 dark:border-blue-400 border-t-transparent rounded-full animate-spin mb-4" />
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">
        {failedReason ? 'Hmm…' : 'Signing you in…'}
      </h1>
      <p className="text-slate-600 dark:text-slate-300 text-sm">
        {failedReason ? 'Taking you back to sign-in.' : 'One moment.'}
      </p>
    </div>
  );
}
